import React from 'react';
import { ExternalLinkIcon, WalletCardsIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { trackSubmitApplication } from '../../utils/metaPixel';
const CHERRY_APPLICATION_URL = 'https://patient.withcherry.com/lipo-laser';
export function CherryFinancing() {
  const {
    lang
  } = useLanguage();
  const copy = lang === 'es' ? {
    eyebrow: 'FINANCIAMIENTO',
    label: 'Aplicar con Cherry',
    description: 'Opciones de pago'
  } : {
    eyebrow: 'FINANCING',
    label: 'Apply with Cherry',
    description: 'Payment options'
  };
  return <a href={CHERRY_APPLICATION_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackSubmitApplication({
    provider: 'cherry',
    slug: 'lipo-laser'
  })} aria-label={`${copy.label} — opens in a new tab`} className="fixed bottom-28 right-4 z-50 inline-flex items-center gap-3 rounded-full border border-[#936C56]/25 bg-[#936C56] px-4 py-3 text-white shadow-xl shadow-black/20 transition-colors hover:bg-[#7c5947] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 md:bottom-6 md:right-6" data-id="element-62" data-mp="33g1g4vb6xwdp">
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/15" data-id="element-63" data-mp="17kbcd55381d2">
        <WalletCardsIcon className="h-4 w-4" strokeWidth={1.8} data-id="element-64" data-mp="257tuv7ojwhu9" />
      </span>
      <span className="flex flex-col items-start leading-none" data-id="element-65" data-mp="259wjbna222wv">
        <span className="mb-1 text-[9px] font-medium tracking-[0.16em] text-white/75" data-id="element-66" data-mp="209s4s2spji9a">
          {copy.eyebrow}
        </span>
        <span className="text-xs font-semibold" data-id="element-67" data-mp="1vg7eyy19pul6">{copy.label}</span>
        <span className="mt-1 text-[10px] text-white/75" data-id="element-68" data-mp="1qhw4cl35fg1w">{copy.description}</span>
      </span>
      <ExternalLinkIcon className="h-3.5 w-3.5 text-white/70" strokeWidth={1.8} data-id="element-69" data-mp="2nyl50bgd4c9p" />
    </a>;
}